export { MapImage } from './MapImage'
